import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setCategoryOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="max-w-[1280px] mx-auto px-4 md:px-6 flex items-center justify-between h-16" aria-label="主导航">
        <Link to="/" className="flex items-center gap-2 group">
          <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-vip-crown-line text-lg"></i>
          </div>
          <span className={`font-heading font-bold text-lg whitespace-nowrap ${
            scrolled || !isHome ? 'text-foreground-900' : 'text-background-50'
          }`}>
            六合彩指南
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          <Link
            to="/"
            className={`px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
              location.pathname === '/'
                ? scrolled || !isHome ? 'text-primary-600 bg-primary-50' : 'text-background-50 bg-background-50/20'
                : scrolled || !isHome ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50' : 'text-background-50/80 hover:text-background-50 hover:bg-background-50/15'
            }`}
          >
            首页
          </Link>

          <div className="relative">
            <button
              onClick={() => setCategoryOpen(!categoryOpen)}
              className={`px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap flex items-center gap-1 ${
                categoryOpen
                  ? scrolled || !isHome ? 'text-primary-600 bg-primary-50' : 'text-background-50 bg-background-50/20'
                  : scrolled || !isHome ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50' : 'text-background-50/80 hover:text-background-50 hover:bg-background-50/15'
              }`}
            >
              分类浏览
              <i className={`ri-arrow-down-s-line text-sm transition-transform ${categoryOpen ? 'rotate-180' : ''}`}></i>
            </button>
            {categoryOpen && (
              <div className="absolute top-full mt-1 left-0 w-56 bg-background-50 rounded-lg border border-background-200/70 py-2 z-50">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="flex items-center gap-3 px-4 py-2.5 hover:bg-primary-50 transition-colors"
                  >
                    <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600">
                      <i className={`${cat.icon} text-sm`}></i>
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-800">{cat.name}</div>
                      <div className="text-xs text-foreground-500">{cat.articleCount}篇文章</div>
                    </div>
                  </Link>
                ))}
              </div>
            )}
          </div>

          <Link
            to="/about"
            className={`px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
              location.pathname === '/about'
                ? scrolled || !isHome ? 'text-primary-600 bg-primary-50' : 'text-background-50 bg-background-50/20'
                : scrolled || !isHome ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50' : 'text-background-50/80 hover:text-background-50 hover:bg-background-50/15'
            }`}
          >
            关于我们
          </Link>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className={`md:hidden w-9 h-9 flex items-center justify-center rounded-lg ${
            scrolled || !isHome ? 'text-foreground-700' : 'text-background-50'
          }`}
          aria-label="打开菜单"
        >
          <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-3">
          <Link
            to="/"
            className={`block px-4 py-3 rounded-lg text-sm font-medium ${
              location.pathname === '/' ? 'text-primary-600 bg-primary-50' : 'text-foreground-700 hover:bg-primary-50'
            }`}
          >
            首页
          </Link>
          <div className="px-4 py-3 text-sm font-medium text-foreground-700">分类浏览</div>
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex items-center gap-3 px-4 py-2.5 hover:bg-primary-50 rounded-lg ml-4"
            >
              <div className="w-7 h-7 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-600">
                <i className={`${cat.icon} text-xs`}></i>
              </div>
              <span className="text-sm text-foreground-700">{cat.name}</span>
            </Link>
          ))}
          <Link
            to="/about"
            className={`block px-4 py-3 rounded-lg text-sm font-medium mt-1 ${
              location.pathname === '/about' ? 'text-primary-600 bg-primary-50' : 'text-foreground-700 hover:bg-primary-50'
            }`}
          >
            关于我们
          </Link>
        </div>
      )}
    </header>
  );
}